import { z } from 'zod';

export const dataSourceSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  sqlQuery: z.string().min(1, 'SQL Query is required'),
});
